export function getEventLink(type, id, title = ''){
    const titleParam = title ? `&title=${encodeURIComponent(title)}` : '';
    if(type == 3){
        return '/auction?id=' + id + titleParam;
    }else if (type == 1 || type == 2){
        return '/showdetails?id=' + id + titleParam;
    }
    else{
        return '';
    }
}

// event Type From Backend )show || Auction

export function getEventType(type){
    if(type == 1){
        return 'show';
    }
    else if(type == 2){
        return 'auction';
    }
    else {
        return 'Unkown event type';
    }
}